import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, tap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard  {
  constructor(
    private authService: AuthService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    // return this.authService.canActivateProtectedRoutes$
    //   .pipe(tap(x => console.log('You tried to go to ' + state.url + ' and this guard said ' + x)));

    return this.authService.isDoneLoading$.pipe(
      filter(isDone => isDone),
      // switchMap(_ => this.authService.isAuthenticated$),
      tap(isAuthenticated => this.authService.hasValidToken() || this.authService.login(state.url))
    );

    // return this.authService.canActivateProtectedRoutes$.pipe(
    //   map((x => {
    //     console.log(this.authService.hasValidToken());
    //     return this.authService.hasValidToken()
    //   }))
    // );

  }
}
